import React, { Component } from 'react';
import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow.tsx';

interface IProps {
    nextStep(): void;
    prevStep(): void;
    gtmEvent(): void;
    updateLead(props: any): void;
    homeValue?: number;
    mortgageAmountRequired?: number;
    title: any;
    subtitle?: any;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    homeValue?: number;
    mortgageAmountRequired?: number;
}


export class BorrowingLevel extends Component<IProps, IState> {

    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, homeValue: this.props.homeValue, mortgageAmountRequired: this.props.mortgageAmountRequired};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep() {
        var errors:string[]=[];
        if (!this.state.homeValue || !this.state.mortgageAmountRequired) {
            if (!this.state.homeValue) {
                errors.push("Home Value is required");
            }
            if (!this.state.mortgageAmountRequired) {
                errors.push("Mortgage Amount is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }

        if (this.state.mortgageAmountRequired / this.state.homeValue > 0.9) {
            errors.push("Mortgage amount required cannot be greater than 90% of the home value")
            //this.setState({errors: errors, hasError: true, mortgageAmountRequired: Math.round(this.state.homeValue * 0.9)});
            this.setState({errors: errors, hasError: true});
            return;
        }

        this.props.nextStep();
    }
    
    render() {

        return (
            <header className="App-header">
                <h1 className='l'>{this.props.title}</h1>
                {this.props.subtitle && <p>{this.props.subtitle}</p>}
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <NumberInput
                                id='homeValue'
                                key='homeValue'
                                label={<>Approximate <strong>Home Value</strong></>}
                                value={this.props.homeValue}
                                classes={this.state.hasError && !this.state.homeValue ? "e" : ""}
                                onChange={(e) => { this.setState({homeValue: e.target.value}); this.props.updateLead({homeValue: e.target.value}); }} />
                                {/* onChange={(e) => { this.setState({homeValue: e.target.value}); this.props.setHomeValue(e.target.value); }} /> */}
                        </div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='mortgagevalue'
                                key='mortgagevalue'
                                label={<>Mortgage <strong>Amount Required</strong></>}
                                value={this.props.mortgageAmountRequired}
                                classes={this.state.hasError && !this.state.mortgageAmountRequired ? "e" : ""}
                                onChange={(e) => { this.setState({mortgageAmountRequired: e.target.value}); this.props.updateLead({mortgageAmountRequired: e.target.value}); }} />
                                {/* onChange={(e) => { this.setState({mortgageAmountRequired: e.target.value}); this.props.setMortgageAmountRequired(e.target.value); }} /> */}
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}
